
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.97 18.267v-.91h8.423v.91H.97zm0 2.837v-.91h8.423v.91H.97zM2.346 12.486c0-.01.01-.056.03-.136a5.99 5.99 0 01.095-.325 3.3 3.3 0 01.133-.347c.145-.282.334-.422.566-.422h.008c.177 0 .327.057.449.172a.745.745 0 01.223.46c.31-.421.691-.632 1.144-.632.214 0 .4.054.559.164.161.11.255.289.281.539.32-.469.72-.703 1.2-.703.228 0 .425.062.59.187.166.125.25.34.25.645 0 .325-.164.92-.49 1.781-.096.29-.144.49-.144.602 0 .153.059.23.176.23.3 0 .548-.333.746-1 .016-.065.03-.103.043-.113.013-.013.044-.02.094-.02.078 0 .117.025.117.075 0 .018-.01.067-.031.148-.021.08-.059.184-.114.309a2.166 2.166 0 01-.19.359c-.074.115-.17.213-.29.297a.67.67 0 01-.39.125.567.567 0 01-.446-.184.68.68 0 01-.16-.457c0-.117.042-.287.125-.511.31-.886.465-1.476.465-1.77 0-.352-.123-.527-.367-.527-.417 0-.793.287-1.13.863-.06.101-.126.293-.199.574a28.676 28.676 0 00-.128.524l-.32 1.277c-.053.138-.148.208-.286.21-.075 0-.133-.021-.172-.066a.213.213 0 01-.054-.144c0-.026.007-.063.023-.11l.523-2.082c.047-.218.07-.391.07-.519 0-.352-.122-.527-.366-.527-.417 0-.793.287-1.13.863-.06.101-.126.293-.199.574-.01.06-.032.147-.066.262a3.103 3.103 0 00-.063.262l-.32 1.277c-.052.138-.148.208-.289.21-.075 0-.131-.021-.168-.066a.213.213 0 01-.055-.144c0-.026.008-.063.024-.11l.601-2.402c.037-.148.055-.284.055-.406 0-.214-.069-.32-.207-.32-.117 0-.217.08-.3.242a3.34 3.34 0 00-.243.71.48.48 0 01-.055.157c-.015.018-.048.027-.097.027-.08-.002-.121-.03-.121-.082z","fill":"currentColor"}})])
          )
        }
      }
    